export const ProfileConstant = {
    CREATE_SOCIAL_SUCCESS: 'CREATE_SOCIAL_SUCCESS',
    CREATE_SOCIAL_FAILED: 'CREATE_SOCIAL_FAILED',
}